<template>
    <div class="in-app-card" v-if="template">
        <InAppPreviewLayout>
            <template v-slot:vertical>
                <div
                    class="in-app-card-vertical"
                    :style="{
                        backgroundColor: template.InAppProps.Styling.MessageBackgroundColor
                    }"
                >
                    <div
                      v-show="template.InAppProps.Image.AfterTitle && title"
                      :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Title.Color,
                                height:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                lineHeight:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                textAlign: template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                            }"
                      class="in-app-card-title in-app-card-vertical__title"
                    >
                      {{ template.Title || template.Subject }}
                    </div>
                    <div
                        class="in-app-card-vertical__banner"
                        :style="{
                            backgroundImage: `url(${template.InAppProps.Image.URL})`,
                            paddingTop: `${100 / numericalSideRatio}%`
                        }"
                        v-show="
                            template.InAppProps.Image.URL &&
                            template.InAppProps.Image.URL.length
                        "
                        @click="onOpenUrl(template.InAppProps.Image.ActionURL)"
                    ></div>
                    <div class="in-app-card-vertical-body" v-show="showVerticalBody">
                        <span
                          v-show="title && !template.InAppProps.Image.AfterTitle"
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Title.Color,
                                height:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                lineHeight:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                textAlign: template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                            }"
                            class="in-app-card-title in-app-card-vertical-body__title"
                            >{{ template.Title || template.Subject }}</span
                        >
                        <span
                            v-show="template.Template"
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Desc.FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Desc.Color,
                                height:
                                    (+template.InAppProps.Styling.Desc
                                        .FontSize +
                                        1) *
                                        textSmallingCoef *
                                        2 +
                                    'px',
                                lineHeight:
                                    +(
                                        template.InAppProps.Styling.Desc
                                            .FontSize + 1
                                    ) *
                                        textSmallingCoef +
                                    'px',
                                textAlign: template.InAppProps.Styling.Desc.AlignLeft ? 'left': 'center'
                            }"
                            class="in-app-card-vertical-body__text"
                            >{{ template.Template }}</span
                        >
                        <div class="in-app-card-vertical-body-buttons">
                            <div
                                class="in-app-card-vertical-body-buttons__wrapper"
                            >
                                <span
                                    v-if="
                                        template.InAppProps.SecondaryButton
                                            .Title
                                    "
                                    @click="
                                        onOpenUrl(
                                            template.InAppProps.SecondaryButton
                                                .ActionURL
                                        )
                                    "
                                    class="in-app-card__button in-app-card-vertical-body__button"
                                    :style="{
                                        color:
                                            template.InAppProps.Styling
                                                .SecondaryButtonColor,
                                        backgroundColor: template.InAppProps.SecondaryButton.BackgroundColor,
                                        borderColor: template.InAppProps.SecondaryButton.BordersColor,
                                        borderStyle: template.InAppProps.SecondaryButton.Title ? 'solid' : 'hidden'
                                    }"
                                    >{{
                                        template.InAppProps.SecondaryButton
                                            .Title
                                    }}</span
                                >
                                <span
                                    v-if="
                                        template.InAppProps.PrimaryButton.Title
                                    "
                                    @click="
                                        onOpenUrl(
                                            template.InAppProps.PrimaryButton
                                                .ActionURL
                                        )
                                    "
                                    class="in-app-card__button in-app-card-vertical-body__button"
                                    :style="{
                                        color:
                                            template.InAppProps.Styling
                                                .PrimaryButtonColor,
                                        backgroundColor: template.InAppProps.PrimaryButton.BackgroundColor,
                                        borderColor: template.InAppProps.PrimaryButton.BordersColor,
                                        borderStyle: template.InAppProps.PrimaryButton.Title ? 'solid' : 'hidden'
                                    }"
                                    >{{
                                        template.InAppProps.PrimaryButton.Title
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:horizontal>
                <div
                    class="in-app-card-horizontal"
                    :style="{
                        display:
                            template.InAppProps.Image.LandscapeURL &&
                            template.InAppProps.Image.LandscapeURL.length
                                ? null
                                : 'block',
                        backgroundColor: template.InAppProps.Styling.MessageBackgroundColor
                    }"
                >
                    <div
                        class="in-app-card-horizontal__banner"
                        :style="{
                            backgroundImage: `url(${template.InAppProps.Image.LandscapeURL})`,
                        }"
                        v-if="
                            template.InAppProps.Image.LandscapeURL &&
                            template.InAppProps.Image.LandscapeURL.length
                        "
                        @click="onOpenUrl(template.InAppProps.Image.ActionURL)"
                    ></div>
                    <div class="in-app-card-horizontal-body">
                        <span
                            class="in-app-card-title in-app-card-horizontal-body__title"
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Title.Color,
                                height:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                lineHeight:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                textAlign: template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                            }"
                            >{{ template.Title || template.Subject }}</span
                        >
                        <span
                            class="in-app-card-horizontal-body__text"
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Desc.FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Desc.Color,
                                height:
                                    (+template.InAppProps.Styling.Desc
                                        .FontSize +
                                        1) *
                                        textSmallingCoef *
                                        3 +
                                    'px',
                                lineHeight:
                                    +(
                                        template.InAppProps.Styling.Desc
                                            .FontSize + 1
                                    ) *
                                        textSmallingCoef +
                                    'px',
                                textAlign: template.InAppProps.Styling.Desc.AlignLeft ? 'left': 'center'
                            }"
                            >{{ template.Template }}</span
                        >
                        <div class="in-app-card-horizontal-body-buttons">
                            <div
                                class="in-app-card-horizontal-body-buttons__wrapper"
                            >
                                <span
                                    v-if="
                                        template.InAppProps.SecondaryButton
                                            .Title
                                    "
                                    @click="
                                        onOpenUrl(
                                            template.InAppProps.SecondaryButton
                                                .ActionURL
                                        )
                                    "
                                    class="in-app-card__button in-app-card-horizontal-body__button"
                                    :style="{
                                        color:
                                            template.InAppProps.Styling
                                                .SecondaryButtonColor,
                                        backgroundColor: template.InAppProps.SecondaryButton.BackgroundColor,
                                        borderColor: template.InAppProps.SecondaryButton.BordersColor,
                                        borderStyle: template.InAppProps.SecondaryButton.Title ? 'solid' : 'hidden'
                                    }"
                                    >{{
                                        template.InAppProps.SecondaryButton
                                            .Title
                                    }}</span
                                >
                                <span
                                    v-if="
                                        template.InAppProps.PrimaryButton.Title
                                    "
                                    @click="
                                        onOpenUrl(
                                            template.InAppProps.PrimaryButton
                                                .ActionURL
                                        )
                                    "
                                    class="in-app-card__button in-app-card-horizontal-body__button"
                                    :style="{
                                        color:
                                            template.InAppProps.Styling
                                                .PrimaryButtonColor,
                                        backgroundColor: template.InAppProps.PrimaryButton.BackgroundColor,
                                        borderColor: template.InAppProps.PrimaryButton.BordersColor,
                                        borderStyle: template.InAppProps.PrimaryButton.Title ? 'solid' : 'hidden'
                                    }"
                                    >{{
                                        template.InAppProps.PrimaryButton.Title
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </InAppPreviewLayout>
    </div>
</template>

<script>
import InAppPreviewLayout from "../InAppPreviewLayout.vue";
export default {
    name: "in-app-card",
    props: {
        template: {
            type: Object,
            default: {},
        },
        isStep: {
          type: Boolean,
          default: false,
        },
    },
    data: () => ({
        textSmallingCoef: 0.7,
    }),
    computed: {
      title() {
        const title = this.isStep ? this.template.Title : this.template.Subject;
        return title.trim();
      },
      showVerticalBody() {
        return this.title && !this.template.InAppProps.Image.AfterTitle ||
          this.template.Template ||
          this.template.InAppProps.PrimaryButton.Title ||
          this.template.InAppProps.SecondaryButton.Title;
      },
      numericalSideRatio() {
        if (this.template.InAppProps.Image.SideRatio === 43) return 1.333;
        if (this.template.InAppProps.Image.SideRatio === 21) return 2;
        return 1.5;
      }
    },
    components: {
        InAppPreviewLayout,
    },
    methods: {
        onOpenUrl(url) {
            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss">
.in-app-card {
    &-title {
      display: block;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__button {
      padding: 0px 10px;
      border-radius: 3px;
      border: 1px solid transparent;
    }
    &-vertical {
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        width: 75%;
        margin: 0 auto;
        position: relative;
        bottom: -20%;

        &__title {
          padding: 0 8px;
          margin: 8px 0 8px;
        }

        &__banner {
            height: 50%;
            background-position: center;
            background-size: cover;
            overflow: hidden;
        }

        &-body {
          display: flex;
          flex-direction: column;
          padding: 8px;
            &__title {
                text-align: center;
                &[style*='display: none'] + .in-app-card-vertical-body__text {
                  margin-top: 0;
                }
            }

            &__text {
                text-align: center;
                display: block;
                margin-top: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: pre-line;
                align-self: stretch;
            }

            &-buttons {
              margin-top: auto;
            }

            &-buttons__wrapper {
              display: flex;
              margin: 0 -4px;
              &:not(:empty) {
                margin-top: 16px;
              }
            }

            &__button {
                width: 100%;
                font-size: 8px;
                text-align: center;
                cursor: pointer;
                overflow: hidden;
                max-width: 100%;
                text-overflow: ellipsis;
                display: block;
                margin: 0 4px;
            }
        }
    }

    &-horizontal {
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        height: 55%;
        width: 60%;
        margin: 0 auto;
        position: relative;
        bottom: -22%;
        display: grid;
        grid-template-columns: 3fr 4fr;

        &__banner {
            height: 100%;
            background-position: center;
            background-size: cover;
            overflow: hidden;
            aspect-ratio: 1;
        }

        &-body {
            display: grid;
            grid-template-columns: 1fr;
            padding: 8px 8px 0 8px;
            height: 100%;

            &__text {
                align-self: baseline;
                font-size: 8px;
                display: block;
                margin-top: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &-buttons {
                display: grid;
                grid-template-columns: 1fr;
                grid-column: 1 / -1;
            }

            &-buttons__wrapper {
                display: grid;
                grid-template-columns: minmax(10px, 1fr) minmax(10px, 1fr);
                align-items: end;
                justify-items: end;
                margin: 0 0 0 auto;
                grid-column-gap: 10px;
            }

            &__button {
                font-size: 8px;
                text-align: center;
                cursor: pointer;
                overflow: hidden;
                max-width: 100%;
                text-overflow: ellipsis;
                display: block;
            }
        }
    }
}
</style>
